import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, Typography, Box, Divider } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';


export default function Welcome() {
    const { inviteeMobileNumber,partnerObj,inviteeObj } = useSelector((state) => state.ecomslice.mlm);
    const removeEmailIdExtension = () => {
       if (partnerObj.firstname) {
           return partnerObj.firstname.replace(/@appmachine\.in$/, '');
       }
    }
    return (
        <Grid container alignItems="center" justifyContent="center" >
            <Grid item xs={12}>
                <Typography variant="h5">
                    Hello <Box component="span" sx={{ color: "primary.main", fontWeight: "bold", }}>{inviteeObj.title}</Box> 
                </Typography>
                <Typography variant="h6" sx={{ paddingTop: 1 }}>
                    Our Business Associate, <Box component="span" sx={{ color: "primary.main", fontWeight: "bold", }}>{removeEmailIdExtension(partnerObj.firstname)}</Box>, has personally invited you to become <Box component="span" sx={{ color: "primary.main", fontWeight: "bold", }}>G&R Business Associate</Box>, which is a platform designed to help individuals achieve financial success and personal growth.
                </Typography>
            </Grid>
            <Grid xs={12} sx={{ padding: 2, }}><Divider sx={{ bgcolor: 'primary.dark', height: 1 }} /></Grid>
            <Grid container justifyContent="flex-start">
                <Typography variant="h5" sx={{fontSize:16, color: "primary.dark"}}>
                    Why become G&R Business Associate?
                </Typography>
            </Grid>

            <Grid container alignItems="center" sx={{ paddingTop: 1 }}>
                <Grid item xs={1}>
                    <TaskAltIcon />
                </Grid>
                <Grid item xs={10} sx={{ paddingLeft: 1 }}>
                    <Typography variant="h6">
                        You & Your referral get Flat 20% discount on every purchase at <strong>G&R</strong> WEB APP.
                    </Typography>
                </Grid>
            </Grid>
            <Grid container alignItems="center" sx={{ paddingTop: 1 }}>
                <Grid item xs={1}>
                    <TaskAltIcon />
                </Grid>
                <Grid item xs={10} sx={{ paddingLeft: 1 }}>
                    <Typography variant="h6">
                        Earn upto 10% on every transaction under your referrals. It is applicable upto 6 levels under your referral hierarchy.
                    </Typography>
                </Grid>
            </Grid>
            <Grid container alignItems="center" sx={{ paddingTop: 1 }}>
                <Grid item xs={1}>
                    <TaskAltIcon />
                </Grid>
                <Grid item xs={10} sx={{ paddingLeft: 1 }}>
                    <Typography variant="h6">
                        Proven and Benefecial Business Association Program.
                    </Typography>
                </Grid>
            </Grid>

            <Grid xs={12} sx={{ padding: 2, }}><Divider sx={{ bgcolor: 'primary.dark' }} /></Grid>
        </Grid>
    )
}